
import { getOrderProcess, configOrderProcess } from '@/api/templateEvaluate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

import OrderProcess from './components/systemProcess.vue';

@Component({
  name: 'SettingOrderInstall',
  components: {
    OrderProcess
  }
})
export default class extends Vue {
  private listData: any = { // 此处重点学习 如果不初始Key 组件接收数据为空
    process: {},
    module: [],
    moduleAuth: {},
    moduleAlias: {}
  }
  private selectedData: any = {}
  private loading = true

  // life circle
  private created() {
    this.getOrderProcess();
  }

  private getOrderProcess() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getOrderProcess(params).then(res => {
      this.loading = false;
      const data = res.data;
      if (data) {
        this.listData.process = data.level.install_module.auth;
        this.listData.module = data.level.install_module.module;
        this.listData.moduleAuth = data.level.install_module.module_auth;
        this.listData.moduleAlias = data.module_alias;
        this.listData.authConfig = data.auth_config;
        this.selectedData = data.install;
      }
    }).catch(err => {
      this.loading = false;
      this.showErrorMsg(err.msg);
    });
  }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
